import React, { ChangeEvent, FC, useEffect } from 'react'

import { Typography, Box, useTheme, Divider } from '@mui/material'
import { sortBy } from 'lodash'
import { useTranslation } from 'react-i18next'

import { CustomCheckBox } from '../../components/CustomCheckBox'
import { TabType } from '../../components/Tabs'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

import { setReportsForPrint } from './ReportsSlice'
import { ReportsEnum } from './types'

export const CreateReportModalBody: FC<{
  reportsList: TabType<ReportsEnum>[]
  setDisableSubmitButton: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ reportsList, setDisableSubmitButton }) => {
  const { t } = useTranslation()
  const { spacing } = useTheme()
  const dispatch = useAppDispatch()

  const sortedReports = sortBy(reportsList, 'label')

  const allReports = sortedReports.map(({ key }) => key)

  const { reportsForPrint } = useAppSelector(({ reports }) => reports)

  const handleCheckAll = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target
    checked ? dispatch(setReportsForPrint(allReports)) : dispatch(setReportsForPrint([]))
  }

  const handleCheckReport = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target
    if (checked) {
      dispatch(setReportsForPrint([...reportsForPrint, name]))
    } else {
      dispatch(setReportsForPrint(reportsForPrint.filter((report) => report !== name)))
    }
  }

  useEffect(() => {
    dispatch(setReportsForPrint(allReports))
  }, [])

  useEffect(() => {
    setDisableSubmitButton(!reportsForPrint.length)
  }, [reportsForPrint])

  return (
    <>
      <Box display="flex" gap={spacing(2)} alignItems="center" mt={spacing(3.75)}>
        <CustomCheckBox
          checked={allReports.length === reportsForPrint.length}
          onChange={handleCheckAll}
          indeterminate={!!reportsForPrint.length && reportsForPrint.length !== allReports.length}
        />
        <Typography variant="body1" fontWeight={500}>
          {t('all', 'All')}
        </Typography>
      </Box>
      <Divider sx={{ marginY: spacing(3) }} />
      <Box sx={{ columnCount: 2 }}>
        {sortedReports.map(({ key, label }) => (
          <Box display="flex" gap={spacing(1.5)} alignItems="center" key={key}>
            <CustomCheckBox
              onChange={handleCheckReport}
              name={key}
              checked={reportsForPrint.includes(key)}
            />
            <Typography variant="body1" fontWeight={500}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  )
}
